import { useCallback, useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';

const useGetDetailStore = (storeId: string, isLazy = false) => {
  const dispatch = useAppDispatch();
  const detailStore = storeSelectors.getDetailStore();

  const mutate = useCallback(
    (storeId: string) => {
      dispatch(storeActions.getDetailStore.fetch(storeId));
    },
    [dispatch, storeId],
  );

  useEffect(() => {
    if (isLazy) return;
    mutate(storeId);
  }, []);

  return {
    detailStore,
    mutate,
  };
};

export default useGetDetailStore;
